"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("components");
const forms_1 = require("../forms");
function AcceptTerms({ terms, handleSubmit }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "terms-container", children: [(0, jsx_runtime_1.jsx)(components_1.H3, { variant: "headline-medium", className: "terms-subtitle", children: "Please confirm the following prior to submitting:" }), !terms.length ? ((0, jsx_runtime_1.jsx)(components_1.Spinner, {})) : ((0, jsx_runtime_1.jsx)(forms_1.AcceptAndSignForm, { handleSubmit: handleSubmit, terms: terms }))] }));
}
exports.default = AcceptTerms;
